/** The two-position pill switch used above a result and on /history — the cut
 * (transcript / subtitles) and the view (player / format). Shared so both keep
 * the same shape: a label, then the buttons inside one frame. */
export const PILL_SWITCH_FRAME =
  'inline-flex items-center gap-0.5 p-0.5 bg-surface-alt border border-border rounded-full'
export const PILL_SWITCH_BUTTON = 'px-3 py-1 text-xs font-medium rounded-full transition-colors'
